var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdubot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.397,
    height: 64.432,
    viewBox: "-8.5 -7.5 36.801 32.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-157.221 -86.14)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.403 98.472q-.045 0-.1-.016-.552-.157-1.065-.157-.267 0-.584.05-.316.048-.682.15.03.211.03.339 0 .453-.056 1.246l1.43-.137q.63-.065.773-.065.143 0 .241.091.098.092.098.245 0 .297-.3.333l-.777.068-1.507.137-.023.44q-.007.206-.007.386 0 .721.104.848.079.092.513.092.202 0 .607-.01.407-.013.613-.013.065 0 .193-.02.127-.023.189-.023.346 0 .346.34 0 .274-.278.33-.306.061-1.328.061-1.011 0-1.298-.267-.314-.29-.314-1.338 0-.21.01-.457.01-.248.026-.535-.035-.075-.035-.16 0-.111.062-.2.065-.942.065-1.392 0-.121-.033-.353-.032-.235-.032-.356 0-.388.326-.388.137 0 .235.095.391-.105.737-.157.35-.052.656-.052.793 0 1.266.19.219.087.219.312 0 .131-.085.232-.095.111-.235.111z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.397 99.983q-.039.48-.039.96 0 1.086.101 1.64.007.046.007.076 0 .13-.091.215-.092.085-.212.085-.203 0-.297-.294-.235.173-.49.261-.25.088-.525.088-.675 0-1.12-.45-.456-.46-.456-1.181 0-.871.46-1.397.463-.525 1.2-.525.38 0 .585.117l.307.226q.045-1.374.107-1.85.043-.29.297-.29.297 0 .297.316 0 .453-.13 2.003zm-1.449.085q-.548 0-.822.326-.274.323-.274.976 0 .42.297.724.3.304.702.304.274 0 .463-.101.11-.06.362-.271.049-.043.095-.101l-.01-.565.003-.378.007-.385q-.124-.265-.33-.395-.205-.134-.493-.134z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.98 100.959l.003.705.003.704q0 .072.01.219.013.147.013.219 0 .14-.094.228-.095.091-.232.091-.251 0-.32-.31-.408.213-.94.213-.427 0-.708-.19-.31-.209-.368-.61-.128-.865-.128-1.54 0-.447.098-1.018.046-.284.31-.284.14 0 .235.091.095.088.095.229 0 .15-.05.48-.045.329-.045.502 0 .545.036.933t.108.623q.107.06.212.092.104.03.205.03.438 0 .924-.141l-.003-.663-.007-.633q0-.704.062-1.223.036-.3.316-.3.14 0 .235.091.095.091.088.228z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.23 102.734q-.734.287-1.876.287-.14 0-.268-.134-.124-.13-.124-.27v-.95q0-.467.059-1.332.065-.933.072-1.35-.003-.3.036-.894.022-.164.107-.216.444-.137 1.009-.137.574 0 1.103.392.61.45.61 1.112 0 .839-.653 1.322.49.209.731.463.245.255.245.555 0 .395-.428.764-.297.26-.623.388zm-.985-4.33q-.356 0-.5.023l-.007.57-.065 1.263q.463.04.496.036.493-.039.806-.306.336-.29.336-.748 0-.31-.342-.574-.343-.264-.725-.264zm.365 2.613l-.346-.055q-.042 0-.13.007-.085.003-.13.003-.177 0-.376-.03-.02.412-.02.735v.675q.855-.03 1.394-.241.228-.088.437-.274.199-.17.199-.255 0-.153-.418-.346-.313-.147-.61-.218z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.229 103.057q-.548 0-.943-.405-.44-.45-.464-1.21-.02-.738.372-1.299.457-.662 1.273-.662.653 0 .989.597.267.483.257 1.161-.01.725-.378 1.237-.418.58-1.106.58zm.196-2.914q-.48-.003-.748.457-.212.369-.212.842t.258.737q.215.219.506.219.34 0 .584-.248.277-.274.294-.741.045-1.263-.682-1.266z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.702 100.084q-.068 0-.163-.007-.091-.007-.16-.007-.075 0-.443.05l.062 1.928.003.143.003.167q.013.714-.343.714-.13 0-.228-.085-.095-.084-.095-.212 0-.124.01-.372t.01-.372l-.065-1.905q-.239-.01-.725-.056-.29-.039-.29-.323 0-.143.088-.238t.225-.095l.685.056q0-.167-.016-.444-.013-.28-.013-.405 0-.137.095-.225.094-.091.231-.091.294 0 .343.48.01.12.01.29l-.007.19-.003.202q.405-.053.463-.053.34 0 .444.033.2.065.2.307 0 .143-.092.238-.088.091-.229.091z",
    fillOpacity: 1,
    strokeWidth: 1.426,
    fontFamily: "Century",
    fontSize: 6.683,
    textAnchor: "middle"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 3.275,
    transform: "matrix(.40632 0 0 .40632 108.737 15.552)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15253a",
    fillOpacity: 1,
    strokeWidth: 4.344,
    d: "M589.096 705.123l-25.06 10.522c-6.995 2.936-18.257 2.936-25.25 0l-25.01-10.5v16.643c-.03.181-.03.363 0 .543v.018h.003c.16.965 1.12 1.913 2.885 2.654l27.764 11.657c3.882 1.63 10.133 1.63 14.015 0l27.764-11.657c1.766-.741 2.725-1.689 2.885-2.654h.004v-.018c.03-.18.03-.362 0-.543z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.275,
    transform: "translate(61.86 30.93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15253a",
    strokeWidth: 1.36,
    d: "M-155.654 229.097h14.353a3.615 3.615 0 013.622 3.622v14.354a3.615 3.615 0 01-3.622 3.622h-14.353a3.615 3.615 0 01-3.623-3.622v-14.354a3.615 3.615 0 013.623-3.622z",
    transform: "scale(1.30397 .54742) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc5959",
    strokeWidth: 3.275,
    d: "M84.993 149.33a.492.492 0 00-.646.263.492.492 0 00.257.647l10.739 4.596v4.575a.492.492 0 00.487.493.492.492 0 00.493-.493v-4.898a.492.492 0 00-.296-.455z",
    color: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc5959",
    strokeWidth: 1.149,
    d: "M97.66 161.238a1.828 1.828 0 01-1.827 1.827 1.828 1.828 0 01-1.828-1.827 1.828 1.828 0 011.828-1.828 1.828 1.828 0 011.828 1.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc5959",
    strokeWidth: 1.149,
    d: "M94.005 168.975c0-1.01.819-7.615 1.828-7.615 1.01 0 1.828 6.605 1.828 7.615a1.828 1.828 0 01-3.656 0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdubot);
export default __webpack_public_path__ + "static/media/edubot.5cc068d9133f539f2f3341e786468c62.svg";
export { ForwardRef as ReactComponent };